import { Injectable, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Observable, BehaviorSubject } from 'rxjs';
import { TranslateService as NGXTranslateService, MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { ShellDomainProvider } from '../../service/utility/shell-domain.provider';
import { UserInfoService } from '../../service/auth/user-info.service';
import { TokenProvider } from '../token/token.provider';
import { EcapCookieService } from '../cookie/ecap-cookie.service';
import { LanguageAction} from '../multi-http-loader/redux-lang-store/language.action';
import * as langFromRoot from '../multi-http-loader/redux-lang-store';
import { Store } from '@ngrx/store';
@Injectable()
export class EcapTranslateService implements OnInit {
    currentLangObservable: BehaviorSubject<string>;
    langKeyMatchRegex: any;
    isPlatformServer: boolean;
    isPlatformBrowser: boolean;

    constructor(private translate: NGXTranslateService,
        @Inject(PLATFORM_ID) platformId: string,
        private store: Store<langFromRoot.State>,
        private _cookieService: EcapCookieService,
        private userInfoService: UserInfoService,
        private tokenProvider: TokenProvider) {
        this.isPlatformServer = isPlatformServer(platformId);
        this.currentLangObservable = new BehaviorSubject('');
    }

    private setDefaultLanguage(useLang: string) {
        this.translate.use(useLang);
        this.store.dispatch(new LanguageAction(useLang));
        this.setLangCookie(useLang);
    }

    private setUserLang(useLangKey, useUserLang?){
        let browserLang = this.getBrowserCurrentLangKey() || (ShellDomainProvider['api'] && ShellDomainProvider['api']['defaultLangKey']) || 'en';
        if(!useUserLang){
            if (ShellDomainProvider['api'] && ShellDomainProvider['api']['defaultLangKey']) {
                useLangKey = ShellDomainProvider['api']['defaultLangKey'];
            } else {
                useLangKey = browserLang.match(this.langKeyMatchRegex) ? browserLang : 'en';
            }
        }
        if (!this.isPlatformServer) {
            if (useUserLang) {
                this.setLangCookie(useLangKey);
                this.translate.use(useLangKey);
                this.store.dispatch(new LanguageAction(useLangKey));
            } else {
                const expectedCookie = this._cookieService.getCookie("langKey");
                if (expectedCookie){
                    this.translate.use(expectedCookie);
                    this.store.dispatch(new LanguageAction(expectedCookie));
                }
                else{
                    this.setDefaultLanguage(useLangKey);
                }

            }
        }
        else
            this.setDefaultLanguage(useLangKey);
        this.currentLangObservable.next(useLangKey);
    }

    public initLang() {
        //let browserCultureLang = 'en-US';
        let useLang = this.getBrowserCurrentLangKey() || (ShellDomainProvider['api'] && ShellDomainProvider['api']['defaultLangKey']) || 'en';

        if(ShellDomainProvider['api'] && ShellDomainProvider['api']['UseUserLangKey']){
            this.userInfoService.currentUser.subscribe((response:any)=>{
                if(response =='DEFAULT_MESSAGE')return;
                let userLangKey = response && response.Language && response.Language.match(this.langKeyMatchRegex);
                useLang = this.getBrowserCurrentLangKey() || (ShellDomainProvider['api'] && ShellDomainProvider['api']['defaultLangKey']) || 'en';
                this.setUserLang(userLangKey?userLangKey[0]: useLang, true);
            });
        }
        else
            this.setUserLang(useLang);
    }

    public enableUserSpecificLang(language: string, defaultLangKey: string) {
      const langs = ShellDomainProvider['api'] && ShellDomainProvider['api']['language'] || [];
      const userLang = langs.map(lang => {
          const matches = language.match(lang.id);
          return matches ? matches[0] : null;
      }).filter(lang => lang !== null)[0];

      this.setUserLang(userLang || defaultLangKey, true);
  }

    public ngOnInit() {
        // TODO
    }

    public getTranslate(): NGXTranslateService {
        return this.translate;
    }

    public changeLanguage(langKey: string) {

      if(!this.userInfoService.userInfo || !this.userInfoService.userInfo.UserId)
        return;

        this.userInfoService.setCurrentLanguageToToken(langKey).subscribe((response: any) => {
            if (response && response.StatusCode == 0) {
                this.tokenProvider.refreshTokenObservable().subscribe((newToken: any) => {
                    this.translate.use(langKey);
                    this.setLangCookie(langKey);
                    this.currentLangObservable.next(langKey);

                    const refreshToken = this.tokenProvider.getRefreshToken();
                    if (refreshToken)
                        this.tokenProvider.setRefreshTokenToCookie(refreshToken);
                });
            }
        });
    }

    public changePortalLanguage(lang: string) {
        this.translate.use(lang);
        this.setLangCookie(lang);
        this.currentLangObservable.next(lang);
    }

    public addLangs(langKeys, langKeyMatchRegex) {
        this.translate.addLangs(langKeys);
        this.langKeyMatchRegex = langKeyMatchRegex;
    }

    public setLangCookie(lang) {
        if (!this.isPlatformServer) {
          this._cookieService.eraseAndSetCookie('langKey',lang);
        }
    }

    // Gets the instant translated value of a key (or an array of keys).
    // /!\ This method is synchronous and the default file loader is asynchronous.
    // You are responsible for knowing when your translations have been loaded and it is safe to use this method.
    // If you are not sure then you should use the get method instead.
    public instantTranslate(mess: string) {
        return this.translate.instant(mess);
    }

    public instantTranslateWithDesiredKey(mess: string, code: string) {
        let currentLanguage: string = this.translate.currentLang;
        this.translate.currentLang = code;
        let result = this.translate.instant(mess);
        this.translate.currentLang = currentLanguage;
        return result;
    }

    // Returns a stream of translated values of a key (or an array of keys) or the key if the value was not found.
    // Without any onLangChange events this returns the same value as get but it will also emit new values whenever the used language changes.
    getTranslationObservabable(key): Observable<string> {
        return this.translate.stream(key);
    }

    // Gets the translated value of a key (or an array of keys) or the key if the value was not found
    getTranslation(key): Observable<string> {
        return this.translate.get(key);
    }
    public getBrowserCurrentLangKey(){
        if (!this.isPlatformServer) {
            return this._cookieService.getCookie("langKey");
        }else{
            return undefined;
        }
    }
}


export class CommonMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        if (
            params.key.match(/\w+\.\w+/) &&
            params.translateService.translations['ru'] &&
            !params.translateService.translations['ru'][params.key]
        ) {
            // console.warn(`Нехватает перевода для "${params.key}"`);
        }
        return params.key;
    }
}
